import { render, staticRenderFns } from "./pk_race.vue?vue&type=template&id=0d5b8524&scoped=true"
import script from "./pk_race.vue?vue&type=script&lang=ts"
export * from "./pk_race.vue?vue&type=script&lang=ts"
import style0 from "./pk_race.vue?vue&type=style&index=0&id=0d5b8524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b8524",
  null
  
)

export default component.exports